<template>
  <app-board v-if="amReady">
    <h4 class="p-3">Resellers</h4>
    <el-dialog :visible.sync="resellerRatesBoardDialog" custom-class="bg-light-gray" title="" top="2vh" width="90%" @close="reloadList">
      <voipResellerRates :showOnlyNewRates="showOnlyNewRates" :showOnlyFixedRates="showOnlyFixedRates" :resellerUserId="resellerData.user_id" :userUsingPrivateRate="userUsingPrivateRate" :userRateStatus="userRateStatus" :customerDisplayName="resellerData.display_name" v-if="resellerRatesBoardDialog"></voipResellerRates>
    </el-dialog>

    <el-dialog :visible.sync="divisionsPercentDialog" title="" top="2vh" width="90%">
      <divisionsPercentForm :afterUpdate="closeDivisionPercent" :editMode="false" v-if="divisionsPercentDialog" :defaultUserId="divisionsPercentUserId"></divisionsPercentForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-6">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
      <div class="col-12 col-md-6 pb-5 text-right">
        <downloadWorkingDestinationsButton></downloadWorkingDestinationsButton>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </app-board>
</template>

<script>

import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import actionsCell from './ag-grid/ActionsCell'
import editOnFlyCell from "@/components/ag-grid-edit-on-fly-cell/View";
import divisionsPercentForm from "@/modules/voip_user_division_profit_percents/form/View";
// import usingPrivateRate from './ag-grid/PrivateRate'
// import hasLcrModule from './ag-grid/hasLcrModule'
// import openRates from './ag-grid/OpenRates'
// import downloadVOSRatesAgButton from './ag-grid/DownloadVOSRatesAgButton'


export default {
  components: {
    divisionsPercentForm: divisionsPercentForm,
    pagination: () => import('@/components/pagination/View.vue'),
    voipResellerRates: () => import('@/modules/voip-reseller-rate/list/page/View'),
    downloadWorkingDestinationsButton: () => import('@/components/download-working-destinations/View')
  },
  data() {
    return {
      divisionsPercentUserId: null,
      divisionsPercentDialog: false,
      showOnlyFixedRates: false,
      showOnlyNewRates: false,
      userUsingPrivateRate: null,
      userRateStatus: null,
      resellerRatesBoardDialog: false,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        rowClassRules: {
          'app-bg-gold-low-alfa': function(params) { return params.data.num_of_new_destinations_rates != '0'; }
        },
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            width: 130,
            field: 'display_name',
            headerName: 'Reseller',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 140,
            field: 'system_profit_percent',
            headerName: 'Percent',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(editOnFlyCell),
            cellRendererParams: {
              props: {
                inputWidth: '60px',
                valuePropertyName: 'system_profit_percent',
                saveAction: this.updateProfitPercent
              }
            }
            /*cellRenderer: (params) => {
              return params.data.system_profit_percent  + '%';
            }*/
          },
          {
            width: 120,
            field: 'vos_recharge_link',
            headerName: 'VOS Link',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 140,
            field: 'vos_username',
            headerName: 'VOS Username',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 140,
            field: 'vos_password',
            headerName: 'VOS Password',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 100,
            field: 'current_rates_counter',
            headerName: 'Rates',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            width: 120,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    updateProfitPercent (agGridParams, newValue, afterSave) {
      let data = {
        user_id:  agGridParams.data.user_id,
        system_profit_percent: newValue
      }

      this.updateCustomerFields({data}).then( () => {
        afterSave()
      })
    },
    ...$mapActions('voip-reseller-rate-api', {
      syncRatesWithWorkingDestinations: 'syncRatesWithWorkingDestinations'
    }),
    syncWithWorkingDestination (params) {
      this.syncRatesWithWorkingDestinations({ data: {}, id: params.data.id})
      this.reloadList()
    },
    reloadList () {
      this.getEntityListData(this.currentPage)
    },
    openResellerNewRatesBoard (params) {
      let data = params.data
      this.showOnlyNewRates = true
      this.showOnlyFixedRates = false
      this.rowToEdit = params.rowIndex
      this.resellerData = data
      this.userRateStatus = (this.showOnlyNewRates) ? '<span class="app-bg-gold-low-alfa pending p-2">New Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.resellerRatesBoardDialog = true
    },
    openFixedRatesOnly (params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = true
      this.rowToEdit = params.rowIndex
      this.resellerData = data
      this.userRateStatus = (this.showOnlyFixedRates) ? '<span class="app-bg-gold-low-alfa pending p-2">Only Fixed Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.resellerRatesBoardDialog = true
    },
    closeDivisionPercent () {
      this.divisionsPercentDialog = false
    },
    openDivisionsPercent (params) {
      let data = params.data
      this.divisionsPercentUserId = data.user_id
      this.divisionsPercentDialog = true
    },
    openResellerRatesBoard (params) {
      let data = params.data
      this.showOnlyNewRates = false
      this.showOnlyFixedRates = false
      this.rowToEdit = params.rowIndex
      this.resellerData = data
      this.userRateStatus = (this.showOnlyNewRates) ? '<span class="app-bg-gold-low-alfa pending p-2">New Rates</span>' : '<span class="voip-call-test-status awaiting-action p-2">All</span>'
      this.userUsingPrivateRate = data.using_private_rate
      this.resellerRatesBoardDialog = true
    },
    downloadVOSRate (params) {
      this.downloadVosRateAction({id: params.data.id})
    },
    ...$mapActions('user-reseller-features-api', {
      updateCustomerFields: 'update'
    }),
    setUserHasLcrModule (params) {
      let data = {
        user_id: params.userId,
        modules: [
          'voip-lcr-menu',
          'voip-lcr-top-destinations'
        ]
      }
      if (params.value) {
        this.giveUserModules({data})
      } else {
        this.removeUserModules({data})
      }
    },
    ...$mapActions('user-api', {
      giveUserModules: 'giveUserModules',
      removeUserModules: 'removeUserModules'
    }),
    setUserUsingPrivateRate(params) {
      let apiData = params.apiData
      let rowData = params.rowData

      let data = {
        using_private_rate: (apiData.value == true)? 1 : 0,
        user_id:  apiData.userId
      }

      /*this.agGrid.rowData[this.rowToEdit] = rowData;
      this.refreshGrid();*/

      this.updateCustomerFields({data})
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('voip-reseller-api', {
      getEntityList: 'list',
      downloadVosRateAction: 'downloadVosRate'
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->voip-reseller->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
